import { RootState } from 'editor/src/store/index';

import { isEmbedded } from '../../watchers/useDisplayMode';

import isAddElementsAllowed from './isAddElementsAllowed';

/**
 * GAPI-61889: the per-image Opacity control is opt-in per host (`enableImageOpacity`).
 * In the embedded (buyer) editor it additionally follows the template's "Add layers"
 * switch, so a template that keeps its layers fixed does not get a new styling control.
 */
const isImageOpacityAllowed = (state: RootState) =>
  !!state.hostSettings.enableImageOpacity && (!isEmbedded || isAddElementsAllowed(state));

export default isImageOpacityAllowed;
